export default __webpack_public_path__ + "static/media/0x123706cdd8e60324e610e9a2cc7012d0f45a5b8e.035d15c7.webp";